<button class="close float-right" matDialogClose>&times;</button>
<div class="row mt-5">
  <div class="col-11">
    <h2 mat-dialog-title>Log:</h2>
  </div>
  <div class="col-1">
    <button mat-raised-button
            [matMenuTriggerFor]="menuExportar"
            [disabled]="(loadingExport$ | async)">
      <loading-icon
        [btnLabel]="'Exportar'"
        [loading]="loadingExport$ | async"
      ></loading-icon>
      <span class="caret"></span>
    </button>
    <mat-menu #menuExportar="matMenu">
      <button mat-menu-item (click)="exportarTxt()">
        <span>Txt</span>
      </button>
    </mat-menu>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div mat-dialog-content class="mat-typography" style="max-height: 100%;">
    <div class="row">
      <div class="col-12 mt-2">
        Mensagem:
      </div>
      <div class="col-12 mt-2">
        <span class="font-weight-bold log-conteudo">{{logErroModel?.errorMessage}}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mt-2">
        Stack:
      </div>
      <div class="col-12 mt-2">
        <span class="log-conteudo">{{logErroModel?.stack}}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>
